import React, { useState } from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from '../CompanyPage/MarkdownContent';
import EditWrapper from '../CompanyPage/EditWrapper';
import QuestionAnswer from '../../components/QuestionAnswer/QuestionAnswer';
import {
  PageWrapper, PageHeader, PageTitle, EditButton, Card, CardTitle,
  Badge, EmptyState,
} from '../CompanyPage/CompanyPage.styles';

const QuestionsAnswersPage = observer(({ company, mode }) => {
  const [editing, setEditing] = useState(false);
  const isReadonly = mode === 'readonly';
  const questions = company?.questionsAndAnswers || [];

  if (editing) {
    return (
      <PageWrapper>
        <PageHeader>
          <PageTitle>Objection Handling</PageTitle>
        </PageHeader>
        <EditWrapper onBack={() => setEditing(false)}>
          <QuestionAnswer company={company} />
        </EditWrapper>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper data-tour="qa-page">
      <PageHeader>
        <PageTitle>Objection Handling</PageTitle>
        {!isReadonly && (
          <EditButton onClick={() => setEditing(true)}>
            {'\u270E'} Edit
          </EditButton>
        )}
      </PageHeader>

      {questions.length === 0 ? (
        <EmptyState>No objections have been added yet.</EmptyState>
      ) : (
        questions.map((qa, i) => (
          <Card key={i}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8, flexWrap: 'wrap' }}>
              <CardTitle style={{ margin: 0 }}>Objection {i + 1}</CardTitle>
              {qa.related_to && <Badge>{qa.related_to}</Badge>}
            </div>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8, color: '#1a2b3d' }}>Objection</div>
              <MarkdownContent markdown={qa.question} />
            </div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 8, color: '#1a2b3d' }}>Response</div>
              <MarkdownContent markdown={qa.answer} />
            </div>
          </Card>
        ))
      )}
    </PageWrapper>
  );
});

export default QuestionsAnswersPage;
